export const articleNormalize = (article: string) => {
  return article.replace(/[^a-zA-Zа-яА-Я0-9]/g, "").toUpperCase();
};
